import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Preloader.css';

export default function Preloader({ onComplete }) {
  const { t } = useTranslation('common');
  const [counter, setCounter] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    // Volontairement bref : cet écran retarde l'affichage du vrai contenu
    // (donc le LCP) à chaque première visite — on garde l'effet de marque
    // mais sans le payer en performance perçue.
    const DURATION = 300;
    const start = Date.now();

    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      const p = Math.min(100, Math.round((elapsed / DURATION) * 100));
      setCounter(p);
      if (p >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          setExiting(true);
          setTimeout(onComplete, 200);
        }, 100);
      }
    }, 16);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <div className={`preloader${exiting ? ' preloader--exit' : ''}`} aria-hidden="true">
      {/* Decorative arcs */}
      <div className="pre-arc pre-arc-1" />
      <div className="pre-arc pre-arc-2" />
      <div className="pre-arc pre-arc-3" />

      {/* Grain overlay */}
      <div className="pre-grain" />

      {/* Main content */}
      <div className="pre-content">
        <div className="pre-accent" />
        <img
          src="/logo-horizontal-white.png"
          alt="L'Envol Digital pour Elles"
          className="pre-logo"
        />
        <div className="pre-bar-track">
          <div className="pre-bar-fill" />
          <div className="pre-bar-glow" />
        </div>
        <p className="pre-tagline">
          <span>{t('preloader.tagline1')}</span>
          <span className="pre-tagline-sep">·</span>
          <span>{t('preloader.tagline2')}</span>
          <span className="pre-tagline-sep">·</span>
          <span>Sénégal</span>
        </p>
      </div>

      {/* Ghost counter */}
      <div className="pre-counter">{String(counter).padStart(2, '0')}</div>

      {/* Bottom strip */}
      <div className="pre-bottom">
        <span className="pre-bottom-left">
          <span className="pre-dot" />
          L'Envol Digital pour Elles
        </span>
        <span className="pre-bottom-right">FESTIC · Dakar · Thiès</span>
      </div>
    </div>
  );
}
